var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCloseCircle(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "18px",
    viewBox: "0 0 18 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "9540BB86-5C1E-4616-8B46-5E64BA9F1B73") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0,
    y: 0,
    width: 1356,
    height: 602,
    rx: 10
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-2.0%",
    y: "-2.5%",
    width: "104.0%",
    height: "109.0%",
    filterUnits: "objectBoundingBox",
    id: "filter-2"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 12,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.04 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Admin",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Consultants-Payroll",
    transform: "translate(-1595.000000, -636.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#F8F8FA",
    x: 0,
    y: 0,
    width: 1680,
    height: 2037
  }), /*#__PURE__*/React.createElement("g", {
    id: "Bg",
    transform: "translate(285.000000, 123.000000)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-2)",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFFFFF",
    fillRule: "evenodd",
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Row-Admins-Copy-7",
    transform: "translate(284.500000, 620.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FFFFFF",
    x: 0,
    y: 0,
    width: 1356,
    height: 48
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(32.000000, 6.000000)",
    fill: "#292929",
    fontFamily: "RedHatDisplay-Medium, Red Hat Display",
    fontSize: 13,
    fontWeight: 400
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(869.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "No-Pay"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 12.7410274,
    y: 23
  }, "P/E 4/22/22, not paying"))))), /*#__PURE__*/React.createElement("g", {
    id: "x-circle",
    transform: "translate(1595.000000, 636.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#B2C5D4",
    cx: 9,
    cy: 9,
    r: 9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.6941601,5.58964825 C13.0377067,5.96630875 13.0393541,6.53421481 12.7166333,6.91208227 L12.6292055,7.00236935 L10.483,8.959 L12.6738832,10.9564563 C13.0819321,11.3286318 13.1110133,11.9611286 12.7388379,12.3691774 C12.3952913,12.7458379 11.8299325,12.799591 11.4240455,12.5129059 L11.3261168,12.434132 L8.99999342,10.312 L6.67388324,12.434132 C6.26583437,12.8063075 5.63333759,12.7772263 5.26116215,12.3691774 C4.91761559,11.9925169 4.91596815,11.4246109 5.23868901,11.0467434 L5.32611676,10.9564563 L7.516,8.959 L5.37079449,7.00236935 C4.96274561,6.63019391 4.93366444,5.99769713 5.30583988,5.58964825 C5.64938644,5.21298775 6.21474527,5.15923464 6.62063222,5.44591975 L6.71856098,5.52469364 L8.99999342,7.605 L11.281439,5.52469364 C11.6894879,5.1525182 12.3219847,5.18159937 12.6941601,5.58964825 Z",
    id: "Combined-Shape",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseCircle);
export default __webpack_public_path__ + "static/media/closeCircle.c2196aa52b0f659b613e83e1b057bec0.svg";
export { ForwardRef as ReactComponent };